import { environment } from '@doltech/core/lib/environment/environment';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { graphCmsLoader, imgProxyLoader } from '@doltech/utils/lib/image-loader';
import Image from 'next/image';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../figma/colors-v2';
import { Link } from '../../figma/Link';
import transparent from '../img/bannerHeaderTransparent.png';
import { DolPremiumPromotion } from './DolPremiumPromotion';

const BannerWrapper = styled.div`
  margin: 0 auto;
  cursor: pointer;
  top: 0;

  .image-wrapper {
    position: relative;
    height: 182px;
    ${fromScreen(1080)} {
      height: 250px;
    }
  }
`;

const HorizontalBannerWrapper = styled.div`
  width: 100%;
  max-height: auto;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    object-fit: cover;
    height: auto;
    align-self: stretch;
  }
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media (max-width: 1279px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
`;

const StyledLink = styled(Link)`
  background-color: ${colorsV2.primary5};
`;

export const HeaderBanner = () => {
  return (
    <StyledLink
      href={`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/schedule`}
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <BannerWrapper id="banner-id">
        <div className="image-wrapper">
          <Image
            objectFit="contain"
            alt="header-banner"
            src={transparent}
            layout="fill"
            width={2000}
            height={516}
            loader={imgProxyLoader}
          />
        </div>
      </BannerWrapper>
    </StyledLink>
  );
};

interface ImageItem {
  src: any;
  width?: number;
  height?: number;
  base64PlaceHolder?: string;
}

export interface HorizontalBannerProps {
  imgVertical?: ImageItem;
  imgHorizontal?: ImageItem;
  href?: string;
}

export const HorizontalBanner = (props: HorizontalBannerProps) => {
  const {
    imgVertical,
    imgHorizontal,
    href = `${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/schedule`,
  } = props;
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer nofollow">
      <HorizontalBannerWrapper className="visible">
        <div className="desktop">
          <Image
            layout="responsive"
            objectFit="cover"
            width={imgVertical?.width || 679}
            height={imgVertical?.height || 1439}
            src={imgVertical?.src || 'https://dummyimage.com/679x1439.png'}
            alt="banner-vertical"
            loader={graphCmsLoader}
          />
        </div>
        <div className="mobile">
          <Image
            layout="responsive"
            objectFit="cover"
            width={imgHorizontal?.width || 2000}
            height={imgHorizontal?.height || 516}
            src={imgHorizontal?.src || 'https://dummyimage.com/2000x516.png'}
            alt="banner-horizontal"
            loader={graphCmsLoader}
          />
        </div>
      </HorizontalBannerWrapper>
    </Link>
  );
};

export const FooterBanner = ({ isDalyNew = false }) => {
  return <DolPremiumPromotion hasImage={false} vertical />;
};
